import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaUserFriends } from "react-icons/fa";
import CalendarioDate from "../components/ui/CalendarioDate";
import SelettoreCamera from "./SelettoreCamera";

/**
 * Il modulo di ricerca: date, ospiti, cerca. Porta alla pagina /camere con la
 * ricerca gia' impostata. Sta nell'hero della home e in cima alla pagina camere.
 */

const GIORNO = 86400000;
const aStringa = (d) => d.toISOString().slice(0, 10);

export default function BarraRicerca({
  dal: dalIniziale,
  al: alIniziale,
  ospiti: ospitiIniziali = 2,
  camera: cameraIniziale = "",
  onCerca,
  ombra = false,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const oggi = aStringa(new Date());
  const domani = aStringa(new Date(Date.now() + GIORNO));

  const [modulo, setModulo] = useState({
    dal: dalIniziale || oggi,
    al: alIniziale || domani,
    ospiti: ospitiIniziali,
    camera: cameraIniziale,
  });

  const invia = (e) => {
    e.preventDefault();

    // Chi sceglie solo l'arrivo intende una notte.
    const partenza =
      modulo.al && modulo.al > modulo.dal
        ? modulo.al
        : aStringa(new Date(new Date(`${modulo.dal}T00:00:00Z`).getTime() + GIORNO));

    const dati = {
      dal: modulo.dal,
      al: partenza,
      ospiti: Math.min(30, Math.max(1, Number(modulo.ospiti) || 2)),
      camera: modulo.camera,
    };
    setModulo(dati);

    if (onCerca) {
      onCerca(dati);
      return;
    }
    const coda = dati.camera ? `&camera=${dati.camera}` : "";
    navigate(`/camere?dal=${dati.dal}&al=${dati.al}&ospiti=${dati.ospiti}${coda}`);
  };

  return (
    <form
      onSubmit={invia}
      className={`w-full bg-[#14120f] text-[#f5f1e8] flex flex-col md:flex-row relative ${
        ombra ? "shadow-[0_10px_40px_rgba(0,0,0,0.35)]" : "border border-[#c9a962]/40"
      }`}
    >
      <CalendarioDate
        className="flex-[2.6] border-b md:border-b-0 md:border-r border-[#2e2921]"
        dal={modulo.dal}
        al={modulo.al}
        onCambia={(v) => setModulo({ ...modulo, ...v })}
      />

      <label className="w-full md:w-44 px-5 py-3 border-b md:border-b-0 md:border-r border-[#2e2921] flex items-center gap-3">
        <FaUserFriends className="text-lux-accent w-4 h-4 shrink-0" />
        <span className="flex-1">
          <span className="block text-[10px] tracking-widest uppercase text-[#c9a962]">
            {t("ricerca.ospiti", "Ospiti")}
          </span>
          <input
            type="number"
            inputMode="numeric"
            min={1}
            max={30}
            value={modulo.ospiti}
            onChange={(e) =>
              setModulo({ ...modulo, ospiti: e.target.value.replace(/\D/g, "").slice(0, 2) })
            }
            onBlur={() =>
              setModulo((m) => ({ ...m, ospiti: Math.min(30, Math.max(1, Number(m.ospiti) || 2)) }))
            }
            className="w-full bg-transparent text-base font-semibold outline-none"
          />
        </span>
      </label>

      <SelettoreCamera
        className="w-full md:flex-1 md:min-w-[14rem] px-5 py-3 border-b md:border-b-0 md:border-r border-[#2e2921]"
        valore={modulo.camera}
        onCambia={(v) => setModulo({ ...modulo, camera: v })}
      />

      <button
        type="submit"
        className="bg-lux-accent-strong hover:bg-lux-highlight text-[#161310] font-bold px-10 py-4 transition-colors whitespace-nowrap"
      >
        {t("ricerca.cerca", "Cerca")}
      </button>
    </form>
  );
}
